import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby-plugin-intl';

import { useMarketingQueryParams } from '../state/MarketingQueryParamsProvider';

const externalUrlRegex = /^(?!\/).+/i;

// eslint-disable-next-line no-useless-escape
const specialLinkRegex = /^\s*(tel:|mailto:|\#[\w-]+)/gi;

const quoterLinkRegex = /quote.(uat.)?pcinsurance.ca/i;

interface ButtonOrLinkProps {
  className?: string;
  activeClassName?: string;
  onClick?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onKeyDown?: (e: any) => void;
  submit?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  href?: string;
  dataTestId?: string;
}
const ButtonOrLink = styled(({
  className,
  activeClassName,
  children,
  onClick,
  onKeyDown,
  submit,
  disabled,
  ariaLabel,
  dataTestId,
  href,
}: PropsWithChildren<ButtonOrLinkProps>) => {
  const { appendParamsToUrl } = useMarketingQueryParams()!;

  if (onClick || submit) {
    return (
      <button
        className={className}
        type={submit ? 'submit' : 'button'}
        onClick={onClick}
        onKeyDown={onKeyDown}
        aria-label={ariaLabel}
        disabled={disabled}
        data-testid={dataTestId}
      >
        {children}
      </button>
    );
  }
  if (href?.match(specialLinkRegex)) {
    return (
      <a
        data-testid={dataTestId}
        className={className}
        aria-label={ariaLabel}
        href={href}
      >
        {children}
      </a>
    );
  }
  if (href?.match(externalUrlRegex)) {
    let externalUrl = href;

    // Append marketing query parameters to the quoter url, if applicable
    if (href.match(quoterLinkRegex)) {
      externalUrl = appendParamsToUrl(externalUrl);
    }

    return (
      <a
        data-testid={dataTestId}
        className={className}
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label={ariaLabel}
        href={externalUrl}
        onKeyDown={onKeyDown}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      data-testid={dataTestId}
      className={className}
      activeClassName={activeClassName}
      aria-label={ariaLabel}
      to={href || '/'}
      onKeyDown={onKeyDown}
    >
      {children}
    </Link>
  );
})``;

export default ButtonOrLink;
